module.exports = __webpack_public_path__ + "static/media/image227.534c5eb2.png";